export const getWordsArray = (answer: string) =>
    answer
        .split(/,|\.|\s/)
        .map((v) => v.trim().toLowerCase())
        .filter((v) => v !== "")
        .filter((value, index, array) => array.indexOf(value) === index);
